<button
  pButton
  [type]="type"
  [icon]="loading ? '' : icon"
  [disabled]="disabled || loading"
  [class]="'custom-button p-2 ps-3 pe-3 ' + class"
  [ngClass]="styleType"
  [style]="style"
  [rounded]="rounded"
  (click)="btnClick.emit()">
  @if (loading) {
    <i class="pi pi-spinner pi-spin"></i>
  }
  <ng-content></ng-content>
</button>
